export default {
  SELECT: 3,
  IMAGE: 2,
  TEXT: 1,
  TABLE: 4,
};

export const typeText = ["Textualna", "Slika", "Uslovna", "Tabelarna"];
